var React = require('react');

function Face (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.9984 21.5C16.9984 17.125 10.911 17.8477 9.99837 15.3758V14.5C13.3041 14.5 16.9984 13.3333 16.9984 13.3333C15.2711 11.8957 15.8381 1.41262 9.9555 1.41262C9.9555 1.41262 9.16187 0.5 8.1355 0.5C0.944748 0.5 2.52441 11.8073 0.665039 13.3333C0.665039 13.3333 3.17687 14.5 6.49925 14.5V15.3758C5.58575 17.8477 0.665039 17.125 0.665039 21.5H16.9984Z"}));
}

Face.defaultProps = {"width":"17","height":"22","viewBox":"0 0 17 22"};

module.exports = Face;

Face.default = Face;
